import { commonFilter } from './filter';

export default {
  pageName: 'feedsSocialMedia',
  pageId: '20002',
  pagePath: '/opinion/socialMedia',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    C_keyword: {
      buttonId: '200020',
    },
    GPT_Get_Btn: {
      buttonId: '2000201',
    },
    GPT_Confirm: {
      buttonId: '2000202',
    },
    ...commonFilter,
  },
};
